






























































































































































import { Component, Vue, Ref } from 'vue-property-decorator';
import NoteIcon from '@/components/Helper/Icon/Svg/NoteIcon.vue';
import { BulletinEntity } from '@/entities/bulletin.entity';
import { UseService } from '@/services/service';
import BulletinService from '@/services/bulletin.service';
import { ValidationObserver } from 'vee-validate';
import ContentEditable from '@/components/Helper/ContentEditable.vue';

@Component<BtnCreateBulletin>({
  components: { ContentEditable, NoteIcon },
})
export default class BtnCreateBulletin extends Vue {
  dialog = false;

  isShowExtension = false;

  payloadBulletin: Partial<BulletinEntity> = {
    title: null,
    content: null,
  };

  image: File = null;

  file: File = null;

  @UseService(BulletinService)
  service: BulletinService;

  @Ref('form') readonly form!: InstanceType<typeof ValidationObserver>;

  async save(): Promise<void> {
    const instance = await this.service.createOne(this.payloadBulletin);
    await this.service.upload(instance.id, {
      image: this.image,
      file: this.file,
    });
    this.dialog = false;
    this.payloadBulletin.title = null;
    this.payloadBulletin.content = null;
    this.image = null;
    this.file = null;
    this.form.reset();
    await this.$router.push(`/bulletin/${instance.id}`);
  }
}
